import AdminAddUser from 'components/AdminAddUser/AdminAddUser'
import AdminUserList from 'components/AdminUserList/AdminUserList'
import DashboardCard from 'components/DashboardCard/DashboardCard'
export interface IAdminUsersProps {
  createUserStatus: any
  resetPagination: () => void
  removeUser: (userId: number) => void
  createUser: (
    values: { username: string; password: string; privilegeLevel: number },
    resetValue: () => void,
  ) => void
  updatePrivilegeLevel: (userId: number, privilegeLevel: number) => void
  updateOrganisationId: (userId: number, OrganisationId: number[]) => void
}
import { useCustomerSettings } from 'hooks/useCustomerSettings'
import { useThrottle } from 'hooks/useThrottle'
import React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AiOutlineSearch } from 'react-icons/ai'

const AdminUsers: React.FC<IAdminUsersProps> = (props) => {
  const {
    removeUser,
    createUser,
    createUserStatus,
    updatePrivilegeLevel,
    updateOrganisationId,
  } = props
  const customerSettings = useCustomerSettings()
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState('')
  const throttledSearchText = useThrottle(searchText, 300)

  return (
    <DashboardCard style={{ display: 'block' }}>
      {customerSettings.emailLogin && (
        <div className="flex flex-col mb-6">
          <span className="mb-4">{t('AdminAddUser.addUser')}</span>
          <AdminAddUser
            createUserStatus={createUserStatus}
            createUser={createUser}
          />
        </div>
      )}
      {t('AdminUsers.handleUsers')}
      <div className="max-w-[300px] flex items-center space-x-2 py-2">
        <AiOutlineSearch className="text-gray-600 text-xl shrink-0" />
        <input
          onChange={(e) => setSearchText(e.target.value)}
          placeholder={t('general.search')}
          className="placeholder-gray-400 text-sm border-none text-gray-700 outline-hidden w-full h-[30px]"
        />
      </div>
      <AdminUserList
        updatePrivilegeLevel={updatePrivilegeLevel}
        removeUser={removeUser}
        updateOrganisationId={updateOrganisationId}
        searchText={throttledSearchText}
      />
    </DashboardCard>
  )
}
export default AdminUsers
